module.exports = __webpack_public_path__ + "img/01.07196518.jpg";